import TaxRateCaptureSetting from './TaxRateCaptureSetting';

export default TaxRateCaptureSetting;
